export default class Hours {
	weekday: number;
	openedAt: string;
	closedAt: string;
	connectedWithPrev = false;
	connectedWithNext = false;
}
